import type { SplitButtonDesignTokens, SplitButtonTokenSections } from '@primeuix/themes/types/splitbutton';

export const root: SplitButtonTokenSections.Root = {
    borderRadius: '{form.field.borderRadius}',
    roundedBorderRadius: '{borderRadius.md}',   // O5: no pill buttons,
    raisedShadow: '{extend.shadowsm}'
};

export default {
    root
} satisfies SplitButtonDesignTokens;